{
  "zh-CN": {
    "labels": {
      "true": "是",
      "false": "否",
      "null": "-",
      "and": "和",
      "hide": "隐藏",
      "show": "显示",
      "only": "仅",
      "description": "描述",
      "unavailable": "不可用",
      "selected": "已选择",
      "actions": "操作",
      "enabled": "已启用",
      "disabled": "已禁用",
      "collapse": "折叠",
      "price": "价格",
      "expand": "展开",
      "distance": "距离",
      "anonymous": "匿名",
      "toggleNavigation": "切换导航",
      "enableYoutube": "点击启用YouTube嵌入或右键复制视频链接",
      "openInNewWindow": "全屏打开",
      "or": "或",
      "deselect": "点击取消选择",
      "networkStatusOffline": "网络状态：离线 - 服务不可用",
      "groups": "分组",
      "features": {
        "stateOn": "已启用",
        "stateOff": "已禁用",
        "stateConditional": "有条件",
        "selfService": "自助服务",
        "selfServiceEnabled": "用户可以切换此功能",
        "selfServiceDisabled": "用户无法切换此功能",
        "actors": "角色",
        "groups": "群组",
        "noGroups": "此功能没有启用的群组。",
        "noActors": "此功能没有启用的个人角色。",
        "user": "用户",
        "fleet": "舰队",
        "actorType": "角色类型",
        "percentageOfActors": "的角色",
        "percentageOfTime": "的时间",
        "currentState": "当前状态",
        "toggle": "切换",
        "settingsIntro": "为您的账户启用或禁用实验性功能。这些功能可能不完整或随时更改。",
        "noFeaturesAvailable": "目前没有可用的自助服务功能。",
        "descriptions": {
          "tools_travel_times": "显示地点之间的预计旅行时间。",
          "tools_cargo_grids": "显示飞船的交互式货物网格查看器。",
          "fleet_starmap": "在舰队成员页面显示 Star Citizen 星图。"
        }
      },
      "oauthApplication": {
        "name": "应用名称",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "redirectUri": "重定向 URI",
        "redirectUriHint": "每行一个 URI。",
        "confidential": "机密",
        "scopes": "权限范围",
        "scopesHint": "如果未选择权限范围，将使用默认范围: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "已解决",
        "unresolved": "未解决"
      },
      "oauthApplications": {
        "settingsIntro": "管理您的 OAuth 应用。这些应用可以代表用户访问 FleetYards API。",
        "name": "应用名称",
        "redirectUri": "重定向 URI",
        "confidential": "机密",
        "clientId": "客户端 ID",
        "clientSecret": "客户端密钥",
        "scopes": "权限范围",
        "defaultScopes": "默认权限范围",
        "confidentialShort": "机密",
        "publicShort": "公开"
      },
      "fleetInviteToken": "舰队邀请",
      "scDataVersion": "补丁版本",
      "lastReload": "最后重载",
      "createdAt": "创建于",
      "updatedAt": "更新于",
      "addToHangar": "添加到机库",
      "home": {
        "search": "搜索飞船..."
      },
      "shop": {
        "rentalPrice": "租赁",
        "sellPrice": "出售价格",
        "buyPrice": "购买价格"
      },
      "shopCommodity": {
        "item": "物品",
        "shop": "商店",
        "sellPrices": "卖出价格",
        "buyPrices": "买入价格",
        "rentalPrices": "租赁价格",
        "confirmed": "已确认?",
        "submittedBy": "提交者",
        "prices": {
          "label": "价格",
          "rentalPrice": "租赁",
          "averageRentalPrice": "rental (Ø)",
          "sellPrice": "售价",
          "averageSellPrice": "sells for (Ø)",
          "buyPrice": "买入价",
          "averageBuyPrice": "buys for (Ø)",
          "rentalPrice1Day": "1 Day for",
          "averageRentalPrice1Day": "1 Day for (Ø)",
          "rentalPrice3Days": "3 Days for",
          "averageRentalPrice3Days": "3 Days for (Ø)",
          "rentalPrice7Days": "7 Days for",
          "averageRentalPrice7Days": "7 Days for (Ø)",
          "rentalPrice30Days": "30 Days for",
          "averageRentalPrice30Days": "30 Days for (Ø)"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "%{year} 新飞船",
          "totalShips": "总飞船数",
          "totalMembers": "总成员数",
          "vehicles": "机库飞船",
          "wishlists": "愿望清单飞船",
          "shipOfTheMonth": "月度飞船"
        },
        "modelsByClassification": "Ships by Classification",
        "modelsBySize": "Ships by Size",
        "vehiclesByModel": "Ships by Model (Top %{limit})",
        "modelsPerMonth": "Ships per Month",
        "modelsByManufacturer": "Ships by Manufacturer",
        "modelsByProductionStatus": "Ships by Production Status",
        "vehiclesPerMonth": "每月机库飞船",
        "topVehiclesByModel": "前 10 机库飞船",
        "shipsOfTheMonth": "月度飞船",
        "crewDeficit": "船员缺口",
        "crewSurplus": "船员盈余",
        "membersByRole": "按角色分组成员"
      },
      "roadmap": {
        "selectWeek": "选择周",
        "shipRoadmap": "飞船路线图",
        "releases": "发布",
        "unscheduled": "未计划",
        "lastUpdate": "最后更新",
        "released": "已发布",
        "recentlyUpdated": "最近更新",
        "committed": "已确认",
        "lastVersion": {
          "active": {
            "false": "条目已从路线图移除",
            "true": "条目已重新添加到路线图",
            "decreased": "Item was removed from the Roadmap",
            "increased": "Item was readded to the Roadmap"
          },
          "committed": "Item was marked as committed",
          "released": "Item was released to PU",
          "release": "Item moved from release %{old} to %{new}",
          "addedToRelease": "Item new in release %{release}"
        },
        "stories": {
          "one": "%{count} Story",
          "other": "%{count} Stories"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Ship",
          "other": "%{count} Ships"
        }
      },
      "rsiRoadmap": "RSI Roadmap",
      "unknown": "未知",
      "none": "-",
      "notAvailable": "N/A",
      "unknownModel": "%{slug} Unknown",
      "not-available": "N/A",
      "receiveSaleNotifications": "",
      "publicUrl": "公开 URL",
      "name": "名称",
      "homepage": "主页",
      "discord": "Discord 服务器",
      "youtube": "Youtube 频道",
      "twitch": "Twitch 频道",
      "guilded": "Guilded 服务器",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "筛选",
      "taxExcluded": "不含增值税",
      "hangar": "机库",
      "public": "公开",
      "hangarStats": "统计",
      "wishlist": "愿望清单",
      "fleetchart": "舰队图表",
      "fleetchartApp": {
        "screenHeight": "屏幕高度",
        "viewpoint": "视角",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "侧面",
          "top": "顶部",
          "angled": "斜角",
          "front": "正面"
        },
        "gridSize": "每格 %{size} 米",
        "mode": "模式",
        "modeOptions": {
          "classic": "经典",
          "panzoom": "v2"
        }
      },
      "fleetStats": "统计",
      "hangarMetrics": {
        "total": "总计",
        "totalMoney": "Money Value",
        "totalCredits": "Credits",
        "totalIngameValue": "机库 aUEC 价值",
        "totalMinCrew": "最少船员",
        "totalMaxCrew": "最多船员",
        "totalCargo": "总货物",
        "largestShip": "最大飞船",
        "smallestShip": "最小飞船",
        "averagePledgePrice": "平均质押价格",
        "flightReady": "可飞行",
        "uniqueModels": "独特型号",
        "manufacturerCount": "制造商",
        "missingClassifications": "缺失角色",
        "wishlistTotalMoney": "愿望清单质押价值",
        "wishlistTotalCredits": "愿望清单游戏内价值"
      },
      "selectModel": "选择飞船",
      "findModel": "输入以查找飞船",
      "find": "输入以搜索",
      "selectUser": "选择用户",
      "findUser": "输入以搜索用户",
      "selectFleet": "选择舰队",
      "findFleet": "输入以搜索舰队",
      "compare": {
        "removeModel": "移除飞船",
        "addModel": {
          "nullablePrompt": "添加飞船"
        },
        "enough": "Don't you think 8 Ships are enough? ;)"
      },
      "cargoRoutes": "货物路线",
      "uecPerUnit": "aUEC / Unit",
      "au": "AU",
      "uec": "aUEC",
      "sell": "卖出",
      "buy": "买入",
      "yourFlagship": "您的旗舰",
      "flagship": "旗舰",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "舰队",
        "fid": "舰队 ID",
        "name": "名称",
        "logo": "标志",
        "rsiSid": "SID",
        "description": "描述",
        "public": "公开舰队视图",
        "publicFleet": "公开舰队",
        "publicStats": "公开统计",
        "publicFleetStats": "公开舰队统计",
        "discord": "Discord 服务器",
        "guilded": "Guilded 服务器",
        "homepage": "主页",
        "twitch": "Twitch 频道",
        "youtube": "Youtube 频道",
        "backgroundImage": "背景图片",
        "ts": "Teamspeak 服务器",
        "awaitingConfirmation": "等待舰队确认",
        "members": {
          "primary": "主舰队?",
          "hideShips": "为此舰队隐藏您的飞船?",
          "shipsFilter": {
            "label": "哪些飞船应该添加到舰队?",
            "nullablePrompt": "未选择选项",
            "field": "飞船选择",
            "values": {
              "all": "所有飞船",
              "hangar_group": "指定机库群组中的所有飞船",
              "hide": "无飞船"
            }
          },
          "hangarGroupId": {
            "field": "机库群组",
            "label": "指定机库群组",
            "nullablePrompt": "未选择群组"
          },
          "total": "总计: %{count}",
          "joined": "加入于",
          "invited": "已邀请",
          "invitedAt": "邀请/请求于",
          "requested": "已请求加入",
          "declined": "已拒绝",
          "pending": "待处理的邀请与请求",
          "accepted": "成员",
          "declinedMembers": "已拒绝",
          "role": "角色",
          "roles": {
            "admin": "管理员",
            "officer": "军官",
            "member": "成员"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "永久",
          "privilegeGroups": {
            "fleet": "舰队",
            "memberships": "成员",
            "invites": "邀请",
            "vehicles": "载具",
            "roles": "角色"
          },
          "privileges": {
            "fleet:update": "更新舰队",
            "fleet:update:images": "更新图片",
            "fleet:update:description": "更新描述",
            "fleet:delete": "删除舰队",
            "fleet:manage": "管理舰队",
            "fleet:memberships:read": "查看成员",
            "fleet:memberships:create": "邀请成员",
            "fleet:memberships:update": "更新成员",
            "fleet:memberships:delete": "移除成员",
            "fleet:memberships:manage": "管理成员",
            "fleet:invites:read": "查看邀请",
            "fleet:invites:create": "创建邀请",
            "fleet:invites:delete": "删除邀请",
            "fleet:invites:manage": "管理邀请",
            "fleet:vehicles:read": "查看载具",
            "fleet:vehicles:create": "添加载具",
            "fleet:vehicles:update": "更新载具",
            "fleet:vehicles:delete": "移除载具",
            "fleet:vehicles:manage": "管理载具",
            "fleet:roles:read": "查看角色",
            "fleet:roles:create": "创建角色",
            "fleet:roles:update": "更新角色",
            "fleet:roles:delete": "删除角色",
            "fleet:roles:manage": "管理角色"
          }
        },
        "inviteUrls": {
          "noLimit": "No limit",
          "noExpiration": "Never expires",
          "usesLeft": "%{count} uses left",
          "used": "已使用 %{count} 次",
          "usedOfLimit": "已使用 %{count} / %{limit}",
          "expiresIn": "Expires in %{time}",
          "expired": "Expired",
          "expiresAfterOptions": {
            "infinite": "Never",
            "30_minutes": "30 minutes",
            "1_hour": "1 hour",
            "6_hours": "6 hours",
            "12_hours": "12 hours",
            "1_day": "1 天",
            "7_days": "7 days"
          },
          "limitOptions": {
            "infinite": "No limit",
            "1": "1 use",
            "5": "5 uses",
            "10": "10 uses",
            "25": "25 uses",
            "50": "50 uses",
            "100": "100 uses"
          }
        }
      },
      "hangarGroup": {
        "name": "名称",
        "color": "颜色",
        "sort": "排序",
        "public": "在公开机库显示?"
      },
      "source": "来源",
      "model": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "inGame": "已实装?",
        "adiMap": "ADI 地图?",
        "ground": "地面载具?",
        "productionNote": "生产备注",
        "rsiId": "RSI ID",
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "scIdentifier": "SC Identifier",
        "price": "价格",
        "pledgePrice": "质押价格",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "质量",
        "minCrew": "最少船员",
        "maxCrew": "最多船员",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "货物",
        "cargoHolds": "货舱",
        "hydrogenFuelTankSize": "氢燃料箱大小",
        "hydrogenFuelTanks": "氢燃料箱",
        "quantumFuelTankSize": "量子燃料箱大小",
        "quantumFuelTanks": "量子燃料箱",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增强）",
        "pitchBoosted": "俯仰（增强）",
        "rollBoosted": "翻滚（增强）",
        "variants": "变体",
        "manufacturer": "制造商",
        "loaners": "借用船",
        "paints": "涂装",
        "modules": "模块",
        "modulePackages": "模块包",
        "upgrades": "升级套件",
        "brochure": "手册",
        "holo": "Holo",
        "angledView": "斜视图",
        "angledViewColored": "斜视图（彩色）",
        "sideView": "侧视图",
        "sideViewColored": "侧视图（彩色）",
        "frontView": "前视图",
        "frontViewColored": "前视图（彩色）",
        "topView": "俯视图",
        "topViewColored": "俯视图（彩色）",
        "onSale": "在售",
        "salesPage": "销售页面",
        "addons": "模块与升级套件",
        "storeImage": "商店图片",
        "wiki": "Star Citizen Wiki",
        "baseModel": "基础型号",
        "fleetchartOffsetLength": "舰队图表长度偏移",
        "fleetchartOffsetBeam": "舰队图表宽度偏移",
        "productionStatus": {
          "in-production": "生产中",
          "in-concept": "概念阶段",
          "ready": "机库就绪",
          "flight-ready": "可飞行",
          "announced": "已公布"
        }
      },
      "models": {
        "extraColumns": "列",
        "table": {
          "columns": {
            "storeImage": "图片",
            "storeImageWide": "宽图片",
            "rsiStoreImage": "RSI 图片",
            "rsiStoreImageWide": "宽 RSI 图片",
            "angledView": "3D 图片",
            "angledViewWide": "宽 3D 图片",
            "rsiId": "RSI ID",
            "hidden": "隐藏",
            "active": "活跃",
            "createdAt": "创建于",
            "updatedAt": "更新于",
            "manufacturerName": "制造商",
            "length": "长度",
            "beam": "宽度",
            "height": "高度",
            "mass": "质量",
            "cargo": "货物",
            "quantumFuelTankSize": "量子燃料",
            "hydrogenFuelTankSize": "氢燃料",
            "minCrew": "船员",
            "maxCrew": "最多船员",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "最大速度",
            "groundMaxSpeed": "地面速度",
            "focus": "定位",
            "productionStatus": "生产状态",
            "price": "价格",
            "pledgePrice": "质押价格"
          }
        }
      },
      "metrics": {
        "info": "信息",
        "levels": "等级",
        "views": "视图",
        "base": "基础",
        "crew": "船员",
        "speed": "速度",
        "cargo": "货物",
        "hardpoints": "挂载点",
        "missileOptions": "导弹选项（如果可用）",
        "topView": "Top View"
      },
      "manufacturer": {
        "longName": "全名",
        "code": "代码",
        "logo": "标志",
        "scRef": "SC Ref"
      },
      "itemPrice": {
        "price": "价格",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "URL",
        "videoType": "类型"
      },
      "modelModule": {
        "name": "名称",
        "description": "描述",
        "price": "价格",
        "pledgePrice": "承诺价格",
        "productionStatus": "生产状态",
        "scKey": "SC Key",
        "storeImage": "商店图片",
        "active": "激活？",
        "hidden": "隐藏？"
      },
      "dock": {
        "name": "名称",
        "dockType": "停靠类型",
        "shipSize": "飞船尺寸"
      },
      "modelHardpoint": {
        "name": "名称",
        "key": "键",
        "source": "来源",
        "group": "群组",
        "hardpointType": "类型",
        "size": "尺寸",
        "category": "分类",
        "subCategory": "子分类",
        "details": "详情",
        "mount": "挂载",
        "itemSlots": "物品槽",
        "loadoutIdentifier": "配置标识"
      },
      "modelHardpointLoadout": {
        "name": "名称"
      },
      "modelUpgrade": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "modelModulePackage": {
        "name": "名称",
        "description": "描述",
        "pledgePrice": "质押价格",
        "modules": "模块",
        "active": "活跃?",
        "hidden": "隐藏?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "旋转 (°)"
      },
      "modelLoaner": {
        "hidden": "隐藏?",
        "loanerModel": "借用型号"
      },
      "modelPaint": {
        "hidden": "隐藏?",
        "active": "活跃?",
        "onSale": "在售",
        "pledgePrice": "质押价格",
        "productionStatus": "生产状态",
        "productionNote": "生产备注"
      },
      "component": {
        "size": "Size: %{size}",
        "grade": "等级",
        "hidden": "隐藏?",
        "componentClass": "组件类别",
        "componentType": "组件类型",
        "componentSubType": "组件子类型",
        "itemType": "物品类型",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "hardpoint": {
        "legend": {
          "headline": "图例",
          "slotTaken": "插槽已占用",
          "slotAvailable": "插槽可用"
        },
        "size": "尺寸",
        "rackSize": "架尺寸",
        "details": "详情",
        "group": "群组",
        "thrusters": {
          "thrust": "推力",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "sources": {
          "game_files": "游戏文件",
          "ship_matrix": "Ship Matrix"
        },
        "fuelTanks": {
          "hydrogen": "氢燃料箱",
          "quantum": "量子燃料箱"
        },
        "jumpDrive": "跳跃引擎",
        "maxContainerSize": "最大集装箱尺寸",
        "groups": {
          "avionic": "航电",
          "system": "系统",
          "propulsion": "推进",
          "thruster": "推进器",
          "weapon": "武器",
          "other": "其他",
          "auxiliary": "辅助",
          "seat": "座位"
        },
        "types": {
          "radar": "雷达",
          "computers": "电脑",
          "power_plants": "发电机",
          "coolers": "冷却器",
          "shield_generators": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fuel_tanks": "燃料箱",
          "quantum_drives": "量子引擎",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "weapons": "武器",
          "turrets": "炮塔",
          "missiles": "导弹",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— 选择模块 —",
        "selectModule": "选择模块",
        "clearModule": "清除选择",
        "categories": {
          "radar": "雷达",
          "armor": "装甲",
          "relay": "中继",
          "countermeasures": "对抗措施",
          "lifesupport": "生命维持",
          "selfdestruct": "自毁",
          "batteries": "电池",
          "computers": "电脑",
          "powerplant": "发电机",
          "cooler": "冷却器",
          "module": "模块",
          "shieldgenerator": "护盾发生器",
          "fuel_intakes": "燃料进气口",
          "fueltanks": "燃料箱",
          "quantumdrive": "量子引擎与跳跃模块",
          "jump_modules": "跳跃模块",
          "jumpdrive": "跳跃模块",
          "quantum_fuel_tanks": "量子燃料箱",
          "main_thrusters": "主推进器",
          "maneuvering_thrusters": "机动推进器",
          "retro_thrusters": "反推推进器",
          "vtol_thrusters": "VTOL 推进器",
          "weapons": "武器",
          "weapon_mounts": "武器挂载",
          "turret": "炮塔",
          "missiles": "导弹",
          "missile_racks": "导弹架",
          "utility_items": "实用设备",
          "utility": "实用设备",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "打捞填充站",
          "cargogrid": "货物网格",
          "seat": "座位"
        }
      },
      "blank": {
        "propulsion": "没有推进系统",
        "ordnance": "没有武器弹药",
        "modular": "没有模块",
        "avionics": "没有航电系统",
        "fleetInvites": "没有邀请",
        "shopCommodities": "没有可用的商品",
        "userShips": "Your Hangar is currently Empty. To Add Ships / Vehicles to Your Hangar click the following Icon on Any Ship in the Database:"
      },
      "user": {
        "rsiHandle": "用户名",
        "location": "位置",
        "currentSystem": "当前星系",
        "tester": "测试者?",
        "avatar": "头像",
        "unconfirmedEmail": "未确认的邮件",
        "saleNotify": "我希望收到销售通知",
        "publicHangar": "公开机库已启用",
        "publicHangarLoaners": "在公开机库显示借用船提示",
        "publicHangarStats": "公开机库统计已启用",
        "publicWishlist": "公开愿望清单已启用",
        "hideOwner": "为舰队隐藏所有权",
        "lastActiveAt": "最后活跃",
        "confirmedAt": "确认于"
      },
      "adminUser": {
        "superAdmin": "超级管理员",
        "passwordConfirmation": "确认密码"
      },
      "vehicle": {
        "name": "名称",
        "states": "状态",
        "serial": "序列号",
        "owner": "指挥官",
        "flagship": "旗舰",
        "wanted": "想要",
        "loaner": "借用",
        "public": "公开可见",
        "fullPublic": "公开可见（包括名称）",
        "publicShort": "公开",
        "nameVisible": "公开可见",
        "saleNotify": "我希望收到销售通知",
        "hangarGroups": "群组",
        "selectGroup": "选择群组",
        "modelPaintSelect": {
          "nullablePrompt": "选择涂装",
          "label": "涂装"
        },
        "bulkGroupEdit": {
          "hint": "现有群组将被覆盖！"
        },
        "hasLoaners": "借用船",
        "boughtViaSelect": {
          "label": "购买方式"
        }
      },
      "image": {
        "active": "活跃?",
        "background": "用作背景?",
        "caption": "标题",
        "enabled": "已启用?",
        "file": "图片文件",
        "global": "全局?",
        "delete": "删除",
        "start": "开始",
        "cancel": "取消",
        "processing": "处理中...",
        "error": "错误",
        "name": "名称",
        "size": "文件大小",
        "dropzone": "将图片拖放到此处",
        "cancelUpload": "取消上传",
        "startUpload": "开始上传",
        "selectImages": "添加图片...",
        "selectFolder": "添加文件夹..."
      },
      "signup": {
        "link": "还没有账户?",
        "privacyPolicy": "创建 FleetYards 账户即表示您同意我们的"
      },
      "privacyPolicy": "隐私政策",
      "login": "用户名或电子邮件",
      "username": "用户名",
      "twoFactorCode": "两步验证码",
      "confirmationCode": "确认码",
      "email": "电子邮件",
      "avatar": "头像",
      "alreadyRegistered": "已有账户?",
      "currentPassword": "当前密码",
      "password": "密码",
      "passwordConfirmation": "确认密码",
      "rememberMe": "记住我",
      "emptyList": "没有 %{name}",
      "all": "全部",
      "supportUs": "Support FleetYards.net",
      "account": {
        "destroyInfo": "If you want to delete Your Account and remove all your Information from Fleetyards.net and its Services click the Button below. Be aware of that this is a permanent Action and can't be reverted."
      },
      "fleets": {
        "logistics": {
          "inventoryCount": "inventories",
          "pending": "pending",
          "inProgress": "in progress",
          "drafts": "drafts",
          "noInventories": "No inventories yet.",
          "noRequests": "No requests found.",
          "noItems": "No items in this inventory.",
          "items": "items",
          "comments": "comments",
          "managedBy": "Managed by",
          "itemName": "Name",
          "category": "Category",
          "quantity": "Quantity",
          "unit": "Unit",
          "notes": "Notes",
          "status": "Status",
          "requested": "Requested",
          "fulfilled": "Fulfilled",
          "itemFulfilled": "Fulfilled",
          "itemPending": "Pending",
          "requestTitle": "Title",
          "description": "Description",
          "requestType": "Type",
          "priority": "Priority",
          "requestedBy": "Requested by",
          "approvedBy": "Approved by",
          "fulfilledBy": "Fulfilled by",
          "addComment": "Write a comment...",
          "states": {
            "draft": "Draft",
            "submitted": "Submitted",
            "approved": "Approved",
            "in_progress": "In Progress",
            "fulfilled": "Fulfilled",
            "rejected": "Rejected",
            "cancelled": "Cancelled"
          },
          "requestTypes": {
            "supply": "Supply",
            "outfitting": "Outfitting",
            "general": "General"
          },
          "priorities": {
            "routine": "Routine",
            "standard": "Standard",
            "urgent": "Urgent",
            "critical": "Critical"
          },
          "searchInventories": "Search inventories...",
          "inventoryName": "Inventory Name",
          "visibility": "Visibility",
          "visibilities": {
            "members_only": "All Members",
            "officers_only": "Officers Only"
          },
          "categories": {
            "commodity": "Commodity",
            "component": "Component",
            "module_item": "Module",
            "ship": "Ship",
            "ammunition": "Ammunition",
            "consumable": "Consumable",
            "other": "Other"
          },
          "units": {
            "scu": "SCU",
            "units": "Units"
          },
          "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
          "imported": "items imported",
          "importErrors": "errors"
        }
      },
      "filters": {
        "components": {
          "name": "名称",
          "itemType": "物品类型",
          "componentClass": "组件类别"
        },
        "shops": {
          "name": "名称",
          "type": "类型",
          "celestialObject": "天体",
          "model": "飞船",
          "equipment": "装备",
          "component": "组件",
          "commodity": "商品",
          "commodityType": "商品类型",
          "starsystem": "星系",
          "station": "空间站"
        },
        "shopCommodities": {
          "commodityType": "商品类型",
          "station": "空间站",
          "shopId": "商店",
          "equipment": "装备",
          "component": "组件",
          "componentItemTypeFilter": "Component Item Types",
          "equipmentItemTypeFilter": "Equipment Item Types",
          "equipmentTypeFilter": "装备类型",
          "equipmentSlotFilter": "Equipment Slot",
          "commodity": "商品",
          "model": "飞船",
          "name": "名称"
        },
        "shopItems": {
          "category": "分类",
          "subCategory": "子分类",
          "name": "名称",
          "manufacturer": "制造商",
          "minPrice": "min. Price",
          "maxPrice": "max. Price"
        },
        "stations": {
          "name": "名称",
          "celestialObject": "天体",
          "starsystem": "星系",
          "type": "空间站类型",
          "shops": "商店",
          "docks": "停靠口",
          "habs": "居住区?",
          "cargoHub": "货运中心?",
          "refinery": "精炼站?"
        },
        "vehicles": {
          "name": "Name or Ship name",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "wanted": "想要",
          "hidden": "隐藏",
          "public": "公开",
          "group": "群组",
          "loaner": "借用船",
          "boughtVia": "购买方式?"
        },
        "tradeRoutes": {
          "sortBy": "Sort by",
          "sortByValues": {
            "percent": "Max. Percent",
            "profit": "Max. Profit"
          },
          "cargoShip": "With Cargoship?",
          "origin": "From?",
          "destination": "To?",
          "excludeCommodityType": "Exclude Commodity Type",
          "originCelestialObject": "Origin Celestial Object",
          "destinationCelestialObject": "Destination Celestial Object",
          "originStarsystem": "Origin Starsystem",
          "destinationStarsystem": "Destination Starsystem"
        },
        "models": {
          "name": "名称",
          "shipRole": "飞船角色",
          "classification": "分类",
          "focus": "定位",
          "manufacturer": "制造商",
          "onSale": "在售",
          "size": "尺寸",
          "dockSize": "停靠尺寸",
          "price": "价格",
          "pledgePrice": "质押价格",
          "productionStatus": "生产状态",
          "lengthLt": "Length <=",
          "lengthGt": "Length >=",
          "beamLt": "Beam <=",
          "beamGt": "Beam >=",
          "heightLt": "Height <=",
          "heightGt": "Height >=",
          "pledgePriceLt": "Pledge Price <=",
          "pledgePriceGt": "Pledge Price >=",
          "priceLt": "价格 <=",
          "priceGt": "价格 >=",
          "willItFit": "Will it Fit?",
          "withCargo": "有货物?",
          "scIdentifierBlank": "没有 SC 标识?",
          "fleetchartImageBlank": "没有舰队图表图片?",
          "holoBlank": "没有 Holo?",
          "frontViewBlank": "没有前视图图片?",
          "topViewColoredBlank": "没有彩色俯视图图片?"
        },
        "modelModules": {
          "name": "名称"
        },
        "manufacturers": {
          "name": "名称",
          "withModels": "有型号的",
          "logoBlank": "无标志"
        },
        "images": {
          "station": "空间站",
          "model": "飞船"
        },
        "users": {
          "search": "搜索",
          "username": "用户名",
          "email": "电子邮件",
          "rsiHandle": "RSI 用户名"
        },
        "fleets": {
          "name": "名称",
          "fid": "FID",
          "member": "成员",
          "members": {
            "role": "角色",
            "state": "状态",
            "acceptedAtGt": "Joined from",
            "acceptedAtLt": "Joined until",
            "invitedAtGt": "Invited from",
            "invitedAtLt": "Invited until",
            "requestedAtGt": "Requested from",
            "requestedAtLt": "Requested until",
            "declinedAtGt": "Declined from",
            "declinedAtLt": "Declined until"
          },
          "inviteUrls": {
            "expiresAfter": "Expire after",
            "limit": "Max number of uses"
          }
        },
        "manufacturer": "制造商"
      },
      "station": {
        "docks": "停靠口",
        "location": "位置",
        "type": "类型",
        "habitation": "居住区",
        "habs": "居住舱",
        "shops": "商店",
        "locationPrefix": {
          "default": "on",
          "asteriod": "on asteroid near",
          "orbit": "in orbit around"
        },
        "locationSuffix": "near %{location}"
      },
      "tradeRoutes": {
        "buy": "Buy for: %{uec}",
        "sell": "Sell for: %{uec}",
        "cargoShip": "for %{cargo} SCU",
        "sortByPercent": "Sort by Percent",
        "sortByProfit": "Sort by Profit",
        "sortByStation": "Sort by Station",
        "showAveragePrices": "Display average Prices",
        "showLatestPrices": "Display latest Prices"
      },
      "hardpoints": {
        "prefix": "使用以下工具试用配置",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer"
      },
      "scunpacked": {
        "prefix": "Loadouts based on Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "选择飞船"
      },
      "addAddon": {
        "nullablePrompt": ""
      },
      "table": {
        "selected": "%{count} 已选择"
      },
      "commodityPrice": {
        "shopId": "商店",
        "station": "空间站",
        "commodityItemType": "商品类型",
        "commodityItemId": "商品物品",
        "item": "ShopCommodity",
        "price": "价格",
        "type": "类型",
        "shop": "商店",
        "submittedBy": "提交者"
      },
      "syncExtension": {
        "warnings": "警告",
        "status": {
          "started": "导入已开始...",
          "finished": "导入完成",
          "failed": "导入失败!"
        },
        "processSteps": {
          "fetchHangar": "正在从 RSI 机库获取数据",
          "submitData": "正在提交数据到 Fleetyards.net 后台"
        },
        "sessionStatus": "RSI 会话状态",
        "checkIdentity": "检查 RSI 会话",
        "identityStatus": {
          "pending": "检查中...",
          "notFound": "未找到",
          "connected": "已连接"
        },
        "platforms": {
          "chrome": "Google Chrome or Chromium based Browsers",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "页面",
          "all": "所有质押物品",
          "ships": "飞船",
          "components": "模块",
          "skins": "涂装",
          "upgrades": "升级"
        },
        "importedItems": {
          "importedVehicles": "已添加飞船",
          "foundVehicles": "找到的飞船",
          "movedVehiclesToWanted": "飞船已移至愿望清单",
          "missingModels": "未找到飞船",
          "importedComponents": "已添加组件",
          "foundComponents": "找到的组件",
          "missingComponents": "未找到组件",
          "missingComponentVehicles": "未找到匹配的飞船用于组件",
          "importedUpgrades": "已添加升级",
          "foundUpgrades": "找到的升级",
          "missingUpgrades": "未找到升级",
          "missingUpgradeVehicles": "未找到匹配的飞船用于升级"
        }
      },
      "cargoGridViewer": {
        "capacity": "容量",
        "maxContainerSize": "最大集装箱",
        "packed": "已装载",
        "totalCargo": "总货物",
        "didNotFit": "放不下",
        "openInTool": "在货物网格工具中打开",
        "myHangar": "仅显示我的飞船",
        "filterShips": "按集装箱大小筛选飞船",
        "addShip": "Add Ship",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "在线用户",
            "totalUsers": "总用户数",
            "totalShips": "总飞船数",
            "newShipsInYear": "%{year} 新飞船",
            "totalFleets": "总舰队数"
          }
        },
        "modelHardpoint": {
          "loadouts": "配置"
        }
      },
      "hangarTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelMinCrew": "船员",
          "modelMaxCrew": "最多船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelFocus": "定位",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格"
        }
      },
      "fleetTable": {
        "extraColumns": "列",
        "columns": {
          "storeImage": "图片",
          "storeImageWide": "宽图片",
          "angledView": "3D 图片",
          "angledViewWide": "宽 3D 图片",
          "modelManufacturerName": "制造商",
          "modelLength": "长度",
          "modelBeam": "宽度",
          "modelHeight": "高度",
          "modelMass": "质量",
          "modelCargo": "货物",
          "modelMinCrew": "船员",
          "modelMaxCrew": "最多船员",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "最大速度",
          "modelGroundMaxSpeed": "地面速度",
          "modelProductionStatus": "生产状态",
          "modelPrice": "价格",
          "modelPledgePrice": "质押价格",
          "owner": "所有者"
        }
      },
      "erkul": {
        "prefix": "Tryout Loadouts with",
        "link": "Erkul's DPS Calculator"
      }
    }
  }
}
